import { useMutation } from '@tanstack/react-query';
import { submitWorkEnvironmentSurvey } from '../../api/workEnvironmentQueries';
import { SubmitWorkEnvironmentSurveyRequest } from '../../api/workEnvironmentTypes';

export const useSubmitWorkEnvironmentSurveyMutation = () => {
  return useMutation({
    mutationFn: (data: SubmitWorkEnvironmentSurveyRequest) => submitWorkEnvironmentSurvey(data),
  });
};
